export default "__VITE_ASSET__CRy4stkr__"